import { get, post } from '../httpMethods';
import { ApiResponse } from '../../types/api';

export interface LabOrder {
  id: string;
  patientId: string;
  doctorId?: string;
  test?: { id: string; name: string; code: string };
  testName?: string;
  status: 'ORDERED' | 'COLLECTED' | 'RECEIVED' | 'PROCESSING' | 'COMPLETED' | 'CANCELLED';
  isUrgent: boolean;
  priority?: string;
  orderedAt?: string;
  collectedAt?: string;
  completedAt?: string;
  createdAt: string;
  patient?: { firstName?: string; lastName?: string; registrationNumber?: string };
}

export interface LabResult {
  id: string;
  orderId: string;
  parameter: string;
  value: string;
  unit?: string;
  referenceRange?: string;
  isCritical: boolean;
  notes?: string;
  createdAt: string;
}

export interface CreateLabOrderDto {
  patientId: string;
  doctorId?: string;
  testName: string;
  priority?: string;
}

export const laboratoryService = {
  getOrders: (status?: string, patientId?: string): Promise<ApiResponse<LabOrder[]>> => {
    const params = new URLSearchParams();
    if (status) params.append('status', status);
    if (patientId) params.append('patientId', patientId);
    const query = params.toString() ? `?${params.toString()}` : '';
    return get<LabOrder[]>(`/lab/orders${query}`);
  },

  createOrder: (data: CreateLabOrderDto): Promise<ApiResponse<LabOrder>> => {
    return post<LabOrder>('/lab/orders', data);
  },

  collectSample: (id: string): Promise<ApiResponse<LabOrder>> => {
    return post<LabOrder>(`/lab/orders/${id}/collect`, {});
  },

  collectByBarcode: (barcode: string): Promise<ApiResponse<LabOrder>> => {
    return post<LabOrder>('/lab/orders/collect-by-barcode', { barcode });
  },

  validateResults: (id: string, validatedById: string): Promise<ApiResponse<LabOrder>> => {
    return post<LabOrder>(`/lab/orders/${id}/validate`, { validatedById });
  },

  getResults: (orderId: string): Promise<ApiResponse<LabResult[]>> => {
    return get<LabResult[]>(`/lab/orders/${orderId}/results`);
  },

  createResult: (data: any): Promise<ApiResponse<LabResult>> => {
    return post<LabResult>('/lab/results', data);
  },
};
